import { Injectable } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable()
export class LegacyRouterService {
  private currentOutlet$: BehaviorSubject<string> = new BehaviorSubject(undefined);

  public ɵitemOutletName() {
    return this.currentOutlet$.asObservable();
  }

  public routes: Observable<Routes> = of(this.router.config);

  constructor(private router: Router) {}
}
